/**
 * UI Layout Constants
 */
export const LAYOUT = {
  /** Minimum margin from top of viewport for positioned elements */
  PANEL_TOP_MARGIN: 80,
  /** Minimum margin from bottom of viewport for positioned elements */
  PANEL_BOTTOM_MARGIN: 10,
  /** Mobile breakpoint width in pixels */
  MOBILE_BREAKPOINT: 768,
} as const;

/**
 * Touch/Click Event Timing Constants (in milliseconds)
 */
export const TIMING = {
  /** Debounce time for iOS touch events */
  IOS_DEBOUNCE_MS: 400,
  /** Debounce time for standard touch events */
  DEFAULT_DEBOUNCE_MS: 300,
  /** Delay before adding click listeners on iOS */
  IOS_LISTENER_DELAY_MS: 150,
  /** Delay before adding click listeners on other platforms */
  DEFAULT_LISTENER_DELAY_MS: 100,
  /** Animation duration for closing transitions */
  CLOSE_ANIMATION_MS: 350,
  /** Cache cleanup interval (5 minutes) */
  CACHE_CLEANUP_INTERVAL_MS: 5 * 60 * 1000,
} as const;

/**
 * Gesture Constants
 */
export const GESTURES = {
  /** Minimum swipe distance to trigger close action */
  SWIPE_THRESHOLD_PX: 50,
} as const;

/**
 * Cache TTL Constants (in milliseconds)
 */
export const CACHE_TTL = {
  /** Summary cache duration (2 hours) */
  SUMMARY: 2 * 60 * 60 * 1000,
  /** Category cache duration (24 hours) */
  CATEGORY: 24 * 60 * 60 * 1000,
  /** Source cache duration (6 hours) */
  SOURCE: 6 * 60 * 60 * 1000,
  /** History cache duration (4 hours) */
  HISTORY: 4 * 60 * 60 * 1000,
  /** Health check cache duration (5 minutes) */
  HEALTH: 5 * 60 * 1000,
} as const;

/**
 * Cache Size Limits
 */
export const CACHE_LIMITS = {
  SUMMARY_MAX_ENTRIES: 50,
  CATEGORY_MAX_ENTRIES: 10,
  SOURCE_MAX_ENTRIES: 20,
  HISTORY_MAX_ENTRIES: 30,
  HEALTH_MAX_ENTRIES: 5,
} as const;
